import Modal from 'react-responsive-modal'
import { useDispatch } from 'react-redux'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Input, Select } from '../../../../components/ModalInputs'
import ModalFooter from '../../../../components/ModalFooter/ModalFooter'
import moment from 'moment'
import {
  createEducationRecord,
  updateEducationRecord
} from '../../../../actions/students/other'

// Конфигурация полей для каждого типа вкладки
const TAB_CONFIG = {
  training_classes: {
    title: 'Запись о переводе',
    fields: [
      { name: 'xp_date', label: 'Дата', type: 'date', required: true },
      { name: 'status', label: 'Результат обучения', type: 'select', options: [
        { value: 'Поступление', name: 'Поступление' },
        { value: 'Переведён', name: 'Переведён' },
        { value: 'Окончил', name: 'Окончил' },
        { value: 'Отчислен', name: 'Отчислен' }
      ]},
      { name: 'prikaz', label: '№ приказа', type: 'text' },
      { name: 'group_to_text', label: 'Класс куда', type: 'text' },
      { name: 'protocol_number', label: 'Номер протокола', type: 'text' },
      { name: 'protocol_date', label: 'Дата протокола', type: 'date' }
    ]
  },
  training_subgroups: {
    title: 'Запись о подгруппе',
    fields: [
      { name: 'xp_date', label: 'Дата', type: 'date', required: true },
      { name: 'title', label: 'Предмет', type: 'text', required: true },
      { name: 'g_from', label: 'Откуда', type: 'text' },
      { name: 'g_to', label: 'Куда', type: 'text' },
      { name: 'class_from', label: 'Класс откуда', type: 'text' },
      { name: 'class_to', label: 'Класс куда', type: 'text' }
    ]
  },
  training_additional: {
    title: 'Дополнительное образование',
    fields: [
      { name: 'xp_date', label: 'Дата', type: 'date', required: true },
      { name: 'title', label: 'Предмет', type: 'text', required: true },
      { name: 'g_from', label: 'Откуда', type: 'text' },
      { name: 'g_to', label: 'Куда', type: 'text' }
    ]
  },
  training_outclass: {
    title: 'Внеурочная деятельность',
    fields: [
      { name: 'xp_date', label: 'Дата', type: 'date', required: true },
      { name: 'title', label: 'Предмет', type: 'text', required: true },
      { name: 'g_from', label: 'Откуда', type: 'text' },
      { name: 'g_to', label: 'Куда', type: 'text' }
    ]
  }
}

export default function EducationModal({ data, closeModal, tabType, studentId, addMode }) {
  const dispatch = useDispatch()
  const config = TAB_CONFIG[tabType] || TAB_CONFIG.training_classes

  const getInitialValues = () => {
    if (addMode) {
      const initial = { xp_date: moment().format('YYYY-MM-DD') }
      config.fields.forEach(field => {
        if (!initial[field.name]) {
          initial[field.name] = ''
        }
      })
      return initial
    }
    return { ...data }
  }

  const handleCreate = async (values) => {
    const success = await dispatch(createEducationRecord(studentId, tabType, values))
    if (success) {
      closeModal()
    }
  }

  const handleUpdate = async (values) => {
    const recordId = data.xp_key
    const success = await dispatch(updateEducationRecord(studentId, tabType, recordId, values))
    if (success) {
      closeModal()
    }
  }

  const {
    values,
    handleChange,
    handleSubmit
  } = useFormik({
    initialValues: getInitialValues(),
    enableReinitialize: true,
    validateOnChange: true,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  const renderField = (field) => {
    const { name, label, type, options, required } = field

    if (type === 'select') {
      return (
        <Select
          key={name}
          label={label}
          name={name}
          value={values[name] || ''}
          onChange={handleChange}
          style={{ width: '200px' }}
        >
          <option value=''>-- Выберите --</option>
          {options?.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.name}</option>
          ))}
        </Select>
      )
    }

    return (
      <Input
        key={name}
        label={label}
        name={name}
        type={type}
        value={type === 'date'
          ? (values[name] ? moment(values[name]).format('YYYY-MM-DD') : '')
          : (values[name] || '')}
        onChange={handleChange}
        error={required && !values[name] ? 'Обязательное поле' : ''}
        style={{ width: type === 'date' ? '150px' : '200px' }}
      />
    )
  }

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      center
      classNames={{
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalHeader}>
          {config.title}
        </div>
        <div className={styles.modalLocal}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
            {config.fields.map(renderField)}
          </div>
        </div>
        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
    </Modal>
  )
}
